var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid", staticStyle: { "min-height": "800px" } },
    [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "b-modal",
            {
              attrs: {
                size: "xl",
                title: "Ajouter un produit gré à gré",
                "hide-footer": ""
              },
              model: {
                value: _vm.afficherModale,
                callback: function($$v) {
                  _vm.afficherModale = $$v
                },
                expression: "afficherModale"
              }
            },
            [
              _c(
                "template",
                { slot: "default" },
                [
                  _c("AjoutProduitGreAGre", {
                    attrs: { familleId: _vm.familleId },
                    on: {
                      "produit-ajoute": function($event) {
                        return _vm.produitAjoute($event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            2
          ),
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "card bg-white" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row align-items-center" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-4 col-xl-auto",
                      staticStyle: { display: "flex" }
                    },
                    [
                      _c(
                        "b-form-select",
                        {
                          staticClass: "selectpicker",
                          attrs: {
                            "value-field": "id",
                            "text-field": "nom",
                            options: _vm.optionsFamilles,
                            title: "Choix de la famille à afficher"
                          },
                          on: {
                            change: function($event) {
                              return _vm.selectFamilleDeProduit($event)
                            }
                          },
                          model: {
                            value: _vm.familleId,
                            callback: function($$v) {
                              _vm.familleId = $$v
                            },
                            expression: "familleId"
                          }
                        },
                        [
                          _c("template", { slot: "first" }, [
                            _c(
                              "option",
                              {
                                attrs: { disabled: "" },
                                domProps: { value: null }
                              },
                              [_vm._v("Sélectionnez une famille...")]
                            )
                          ])
                        ],
                        2
                      ),
                      _vm.familleId && !_vm.surGreAGre
                        ? _c(
                            "button",
                            {
                              staticClass: "btn vertAgap",
                              attrs: {
                                type: "button",
                                title: "Trier par ordre alphabétique"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.surReordonnerFamille()
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-sort" })]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  !_vm.surGreAGre || _vm.familleId
                    ? _c("div", { staticClass: "col-4 col-xl-auto" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.termeDeRecherche,
                              expression: "termeDeRecherche"
                            }
                          ],
                          staticClass: "input-search",
                          attrs: { type: "text", placeholder: _vm.placeholder },
                          domProps: { value: _vm.termeDeRecherche },
                          on: {
                            keyup: _vm.startTimeoutRecherche,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.termeDeRecherche = $event.target.value
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm.showSortingElements
                    ? _c(
                        "div",
                        { staticClass: "col-12 col-xl-auto" },
                        [
                          _c("b-pagination", {
                            staticClass: "flex-center-center",
                            attrs: {
                              "total-rows": _vm.totalRows,
                              "per-page": _vm.perPage
                            },
                            model: {
                              value: _vm.currentPage,
                              callback: function($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.surGreAGre
                    ? _c("div", { staticClass: "col-12 col-xl-auto" }, [
                        _vm.showSortingElements
                          ? _c(
                              "div",
                              { attrs: { id: "checkboxes" } },
                              _vm._l(_vm.statuses, function(status, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass:
                                      "form-check background-primary form-check-inline"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: status.checked,
                                          expression: "status.checked"
                                        }
                                      ],
                                      staticClass: "form-check-input",
                                      attrs: {
                                        type: "checkbox",
                                        id: "checkbox" + index
                                      },
                                      domProps: {
                                        checked: Array.isArray(status.checked)
                                          ? _vm._i(status.checked, null) > -1
                                          : status.checked
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a = status.checked,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  status,
                                                  "checked",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  status,
                                                  "checked",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(status, "checked", $$c)
                                          }
                                        }
                                      }
                                    }),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "form-check-label",
                                        attrs: { for: "checkbox" + index }
                                      },
                                      [_vm._v(_vm._s(status.value))]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ])
                    : _vm.familleId
                    ? _c(
                        "div",
                        {
                          staticClass: "col-4 col-xl-auto",
                          on: {
                            click: function($event) {
                              return _vm.ajouterProduitGreAGre()
                            }
                          }
                        },
                        [_vm._m(0)]
                      )
                    : _vm._e(),
                  (!_vm.surGreAGre || _vm.familleId) && _vm.avertissements
                    ? _c("div", { staticClass: "col-4 col-xl-auto" }, [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: {
                                  content: _vm.filtrerAvertissements
                                    ? "Filtre actif (" +
                                      _vm.nombreAvertissements +
                                      ")"
                                    : _vm.avertissements,
                                  placement: "bottom",
                                  classes: ["tooltip-light"]
                                },
                                expression:
                                  "{\n                content: (filtrerAvertissements\n                  ? ('Filtre actif (' + nombreAvertissements + ')')\n                  : avertissements),\n                placement: 'bottom',\n                classes: ['tooltip-light']\n              }"
                              }
                            ],
                            class:
                              "btn btn-danger" +
                              (_vm.filtrerAvertissements ? "" : " disabled"),
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.filtrerAvertissements = !_vm.filtrerAvertissements
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-exclamation-triangle"
                            }),
                            _vm._v(" Avertissements produits ")
                          ]
                        )
                      ])
                    : _vm._e(),
                  !_vm.surGreAGre || _vm.familleId
                    ? _c("div", { staticClass: "col-4 col-xl-auto" }, [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: {
                                  content:
                                    "L’affichage des allergènes est effectué à titre informatif.<br />Chaque utilisateur du logiciel doit vérifier par lui-même la véracité de ces informations auprès du ou des fournisseurs de denrées alimentaires concernés.<br />En cas d’erreur, l’utilisateur ne pourra pas engager la responsabilité de la société Agap’pro, éditrice du logiciel.",
                                  placement: "bottom",
                                  classes: ["tooltip-light"]
                                },
                                expression:
                                  "{ \n                content: 'L\\’affichage des allergènes est effectué à titre informatif.<br />Chaque utilisateur du logiciel doit vérifier par lui-même la véracité de ces informations auprès du ou des fournisseurs de denrées alimentaires concernés.<br />En cas d\\’erreur, l\\’utilisateur ne pourra pas engager la responsabilité de la société Agap\\’pro, éditrice du logiciel.', \n                placement: 'bottom', \n                classes: ['tooltip-light']\n              }"
                              }
                            ],
                            staticClass: "btn btn-warning disabled",
                            attrs: { type: "button" }
                          },
                          [
                            _c("i", { staticClass: "fa fa-info" }),
                            _vm._v(" Informations allergènes ")
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _vm.produitsAffiches && _vm.produitsAffiches.length
        ? _vm._l(_vm.produitsAffiches, function(item, index) {
            return _c(
              "div",
              {
                key: item.produitId,
                on: {
                  click: function($event) {
                    _vm.selectedTab = item
                  }
                }
              },
              [
                (_vm.filterEstOk && _vm.estOk(item)) ||
                (_vm.filterAfaire && _vm.aFaire(item)) ||
                (_vm.filterInvalide && _vm.invalide(item)) ||
                _vm.filterVide
                  ? _c(
                      "div",
                      [
                        _c("FicheTechnique", {
                          ref: item.produitId,
                          refInFor: true,
                          class: { activeTab: _vm.selectedTab === item },
                          attrs: {
                            index: index,
                            listData: _vm.produitsAffiches,
                            produit: item,
                            familleId: _vm.familleId,
                            fournisseurs: _vm.fournisseurs,
                            filters: _vm.selectedFilters,
                            selected: _vm.selectedTab === item,
                            surGreAGre: _vm.surGreAGre
                          },
                          on: {
                            "produit-supprime": function($event) {
                              return _vm.produitSupprime()
                            },
                            "raz-tarifs": function($event) {
                              return _vm.RAZTarifs($event)
                            },
                            "produit-modifie": function($event) {
                              return _vm.surProduitModifie()
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          })
        : _vm._e(),
      _vm.produitsAffiches && _vm.produitsAffiches.length == 0
        ? [_vm._v("   Aucun produit trouvé ")]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn vertAgap", attrs: { type: "button" } },
      [_c("i", { staticClass: "fas fa-plus" }), _vm._v(" Ajouter un produit ")]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }